var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassportTip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#EFF2F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5880_8618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0273 31.1067C20.0273 27.793 22.7136 25.1067 26.0273 25.1067H53.9723C57.286 25.1067 59.9722 27.793 59.9722 31.1067V48.8932C59.9722 52.2069 57.286 54.8932 53.9722 54.8932H26.0273C22.7136 54.8932 20.0273 52.2069 20.0273 48.8932V31.1067Z",
    stroke: "#1D252D",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.1125,
    cy: 37.9338,
    rx: 3.44353,
    ry: 3.44353,
    stroke: "#1D252D",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7764 46.1984C28.388 43.822 30.5452 42.0662 33.1124 42.0662C35.6797 42.0662 37.8369 43.822 38.4485 46.1984",
    stroke: "#1D252D",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8203 43.9119H53.343",
    stroke: "#D5A34D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8203 37.2451L48.9525 37.2451",
    stroke: "#D5A34D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5880_8618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.4545,
    height: 45.4545,
    fill: "white",
    transform: "translate(17.2725 17.2727)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassportTip);
export default __webpack_public_path__ + "static/media/passport_tip.c2a47d0cf99e44ec73af50c26fb5dc2a.svg";
export { ForwardRef as ReactComponent };